import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Title } from "@angular/platform-browser";
import { CourseService, Course } from 'src/app/core/http/course/course.service';
import { BreadcrumbService } from 'angular-crumbs';
import { TitleAndCrumbServiceService } from 'src/app/shared/services/title/title-and-crumb-service.service';
@Component({
  selector: 'app-lessons',
  templateUrl: './lessons.component.html',
  styleUrls: ['./lessons.component.css']
})
export class LessonsComponent implements OnInit {
  course_id: string;
  valueBar = (22/44)*100;
  course: Course;
  constructor(private route: ActivatedRoute, private TACServices:TitleAndCrumbServiceService, private courseService: CourseService) {
    this.course_id = this.route.snapshot.paramMap.get("course");
  }

  ngOnInit() {
    this.getCourse();
  }

  getCourse() {
    this.courseService.GetCurrentCourse(this.course_id)
    .subscribe(resp=> {
      this.course = resp;
      console.log(this.course);
      this.TACServices.changeTitleAndCrumb(this.route, this.course.name);
    })
  }
  

}
